import { HStack, Text } from 'native-base'

import { Warning } from '@phosphor-icons/react'

import { colors } from '../../utils/theme/configureTheme'

/** Displays an error banner when the selected open/close time window is too small. */
export default function TimeWindowError() {
  return (
    <HStack backgroundColor={colors.vermillion[100]} p={2} borderRadius={4} space={2}>
      <Warning size={24} color={colors.vermillion[500]} weight="bold" />
      <Text
        color={colors.vermillion[500]}
        fontSize="xs"
        fontWeight="400"
        lineHeight="125%"
        letterSpacing="-1%"
        alignSelf="center"
      >
        Deliveries require at least a 6 hour window.
      </Text>
    </HStack>
  )
}
